import { render, staticRenderFns } from "./Pop.vue?vue&type=template&id=b15dea12&scoped=true&"
import script from "./Pop.vue?vue&type=script&lang=js&"
export * from "./Pop.vue?vue&type=script&lang=js&"
import style0 from "./Pop.vue?vue&type=style&index=0&id=b15dea12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15dea12",
  null
  
)

export default component.exports